import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input, InputProps } from '../../UI';
import { UserFormValues } from '../types';
import { FC } from 'react';

type UserFamilyNameInputProps = Pick<InputProps, 'label' | 'className'> &
  InputProps['inputProps'];

export const UserFamilyNameInput: FC<UserFamilyNameInputProps> = ({
  label,
  required,
  className,
  ...inputProps
}) => {
  const { t: tForm } = useTranslation('form');
  const {
    register,
    formState: { errors },
  } = useFormContext<UserFormValues>();

  return (
    <Input
      className={className}
      {...register('familyName', { required })}
      label={label ?? tForm('user-family-name-input-label')}
      status={errors.familyName ? 'errored' : 'normal'}
      inputProps={{
        placeholder: required ? tForm('general-required-placeholder') : '',
        ...inputProps,
      }}
    />
  );
};
